export const filters = ["tudo", "nabla", "pessoas", "fora", "nao-aplicadas", "em-revisao", "rodadas"] as const;
type Filter = (typeof filters)[number];

function isFilter(value: string | null): value is Filter {
  return filters.some((filter) => filter === value);
}

export interface JournalFilter {
  readonly filtro: Filter;
  readonly objeto?: string;
  readonly pessoa?: string;
}

export function filterOf(query: URLSearchParams): JournalFilter {
  const filtro = query.get("filtro");
  const objeto = query.get("objeto");
  const pessoa = query.get("pessoa");
  return { filtro: isFilter(filtro) ? filtro : "tudo", ...(objeto ? { objeto } : {}), ...(pessoa ? { pessoa } : {}) };
}

export function journalQuery(query: URLSearchParams): Readonly<Record<string, string | undefined>> {
  const { filtro, objeto, pessoa } = filterOf(query);
  return { filtro: filtro === "tudo" ? undefined : filtro, objeto, pessoa };
}

export function journalHref(current: JournalFilter, change: Partial<Record<keyof JournalFilter, string | undefined>>): string {
  const next = { ...current, ...change };
  const params = new URLSearchParams();
  if (next.filtro !== undefined && next.filtro !== "tudo") params.set("filtro", next.filtro);
  if (next.objeto !== undefined) params.set("objeto", next.objeto);
  if (next.pessoa !== undefined) params.set("pessoa", next.pessoa);
  const search = params.toString();
  return search === "" ? "/registro" : `/registro?${search}`;
}
